<!-- 缺陷reopen -->
<template>
  <div>
    <a-row>
      <a-col :span="24">
        <a-card title="AI总结本阶段问题类型分布" size="small">
          <div id="ai-ticket-type" :style="{ height: height, width: width }" />
        </a-card>
      </a-col>
      <a-col :span="24">
        <a-card title="本阶段热点问题" size="small">
          <a-table :columns="ticketListColumns" :pagination="pagination" :style="{ height: height, width: width }" :data-source="ticketTableData" row-key="id" @change="handleTableChange">
            <span slot="trend" slot-scope="text, record">
              <span v-if="record.last_period != 0" :style="{ color: 'red' }"> {{ (((record.this_period - record.last_period) * 100) / record.last_period).toFixed(2) }}% </span>
              <span v-if="record.last_period == 0" :style="{ color: 'red' }"> {{ '本阶段新增' }} </span>
              <span>
                {{ record.this_period > record.last_period ? '↑' : '↓' }}
              </span>
            </span>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
    <div v-if="tableData">
      <ticket-list-modal ref="ticketListModal" :task-list="tableData" :target-columns="columnsList" :width="900" />
    </div>
  </div>
</template>
<script>
import { ticketAIResult } from '@/api/data/ticket';
import TicketListModal from '@/pages/data/ticket/components/TicketListModal';
import { ticketDomain, ticketAiResultPie } from '@/utils/dictionary';
export default {
  components: { TicketListModal },
  props: {
    width: {
      type: String,
      default: '95%'
    },
    userList: {
      type: Array,
      default: null
    },
    tagList: {
      type: Array,
      default: null
    },
    height: {
      type: String,
      default: '360px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    taskMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columnsList: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 70,
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '标题',
          width: 300,
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        }
      ],
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 4, // 每页中显示20条数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      myChart: null,
      myDomainChart: null,
      myAiResultChart: null,

      loading: true,
      ticketDomain,
      ticketAiResultPie,
      title: '',
      tableData: [],
      ticketList: [],
      ticketTableData: [],
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '任务名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        }
      ],
      ticketListColumns: [
        // {
        //   title: 'id',
        //   dataIndex: 'id',
        //   key: 'id',
        //   scopedSlots: { customRender: 'id' }
        // },
        // {
        //   title: 'id',
        //   dataIndex: 'id',
        //   key: 'id',
        //   scopedSlots: { customRender: 'id' }
        // },
        {
          title: '问题类型',
          dataIndex: 'question_type',
          key: 'question_type',
          scopedSlots: { customRender: 'question_type' }
        },
        // {
        //   title: '上个阶段数量',
        //   dataIndex: 'last_period',
        //   key: 'last_period',
        //   scopedSlots: { customRender: 'last_period' }
        // },
        {
          title: '当前阶段数量',
          dataIndex: 'this_period',
          key: 'this_period',
          scopedSlots: { customRender: 'this_period' }
        },
        {
          title: '走势',
          dataIndex: 'trend',
          key: 'trend',
          scopedSlots: { customRender: 'trend' }
        }
      ],
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              // 如果标签长度超过4，将剩余的文字替换为省略号
              value = value.replace('MRD', '');
              if (value.length > 5) {
                return value.slice(0, 5) + '...';
              } else {
                return value;
              }
            }
          }
        },

        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            endValue: 18
          }
        ]
      }
    };
  },
  computed: {
    taskLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:event:ticket:detail',
          query: { ticketId: record.id }
        });
        return route.href;
      };
    }
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById('ai-ticket-type'));
    this.myChart.on('click', params => {
      this.tableData = this.ticketList[params.dataIndex];
      this.title = params.data.name;
      this.$refs.ticketListModal.open();
    });
  },

  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.filterForm.sort_field = sorter.field;
      this.filterForm.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
    },
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    getDiagramData() {
      this.loading = true;
      ticketAIResult(this.filterForm).then(res => {
        const x_axis = [];
        const point_count_series = [];
        this.option.series = [
          {
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            name: '出现次数',
            data: [],
            detail: []
          }
        ];
        if (res.data.length > 0) {
          this.ticketTableData = res.data[1].choices[0].message.content;
          res.data[0].choices[0].message.content.forEach(item => {
            x_axis.push(item.question_type);
            point_count_series.push(item.appears);
            this.ticketList.push(item.ticket_id);
          });
          this.option.xAxis.data = x_axis;
          this.option.series[0].data = point_count_series;
          this.option.series[0].detail = this.ticketList;
          this.loading = false;
          this.drawChart();
        }
      });
    }
  }
};
</script>
